import { callApiAsync, getExternalClientSatisfactionData } from '../../../services/apiService'

export const fetchTableData = async (
    clientName,
    year,
    page,
    pageSize,
    setTableData,
    setTotalRecords,
    setLoading
) => {
    await callApiAsync(
        () => getExternalClientSatisfactionData(clientName, year, page, pageSize),
        (resp) => {
            const data = resp?.data ?? resp;
            const items = Array.isArray(data?.data)
                ? data.data
                : Array.isArray(data?.items)
                    ? data.items
                    : Array.isArray(data)
                        ? data
                        : [];
            const total = Number(data?.total) || Number(data?.totalRecords) || items.length;
            setTableData(items);
            setTotalRecords(total);
        },
        setLoading
    );
};

export const fetchClientOptions = async (setClientOptions) => {
    await callApiAsync(
        () => getExternalClientSatisfactionData(null, null, 1, 1000),
        (resp) => {
            const data = resp?.data ?? resp;
            const items = Array.isArray(data?.data)
                ? data.data
                : Array.isArray(data?.items)
                    ? data.items
                    : Array.isArray(data)
                        ? data
                        : [];
            const uniqueClients = [...new Set(items.map((item) => item.clientName).filter(Boolean))].sort();
            setClientOptions([
                { name: "Seleccionar Cliente", value: null },
                ...uniqueClients.map((name) => ({ name: String(name), value: name }))
            ]);
        },
        null
    );
};
